import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RequestService } from '../../../../request/request.service';
import { MessageService } from '../../../services/message.service';

@Component({
  standalone: false,
  selector: 'app-request-autocomplete',
  templateUrl: './request-autocomplete.component.html',
  styleUrls: ['./../autocomplete.component.scss']
})

export class RequestAutocompleteComponent {
  @Input() placeholder: string;
  items: Array<any> = [];
  input: string;
  isListVisible: boolean;

  @Output() readonly selected: EventEmitter<any> = new EventEmitter<any>();

  constructor(private requestService: RequestService,
              private message: MessageService) {}

  getAllItems(): any {
    this.getRequests();
  }

  getRequests(): any {
    this.requestService.getListOfPreviousWorkRequests(0, 50, this.input).subscribe(
      res => {
        this.items = res.results;
        this.isListVisible = this.items.length > 0 && this.input.length > 0;
      },
      err => this.message.error(err)
    )
  }

  onSelect(item: any): any {
    this.selected.emit(item);
    this.isListVisible = false;
    this.input = '';
  }

  trackByFn(index: number): number {
    return index;
  }
}